/*
 * CreateExtract.tsx
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 15:16:59
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React from 'react';
import classNames from 'classnames';
import UploadFile from 'components/uploadFile';
import positionStyles from 'components/position.less';
import Styles from './index.less';
var CreateExtract = function () {
    return (React.createElement("div", { className: classNames(Styles.createExtract, positionStyles.inTheMiddle) },
        React.createElement(UploadFile, null)));
};
export default CreateExtract;
